<template>
  <div>
    <component :is="asyncComponent" v-bind="$attrs" v-on="$listeners"></component>
  </div>
</template>

<script>
export default {
  name: "MainMenuLayout",
  inheritAttrs: false,
  props: {
    version: {
      type: String,
      required: false,
      default: 'v1'
    }
  },
  computed: {
    asyncComponent() {
      const version = this.version
      return () => import(`./Layout-${version}.vue`)
    }
  }
}
</script>
